var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from 'styled-components';
import { top, right, bottom, left, zIndex, compose } from 'styled-system';
import styledSystemPropTypes from '@styled-system/prop-types';
import { Box } from '../Box';
var Absolute = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n\n  ", "\n"], ["\n  position: absolute;\n\n  ", "\n"])), function (props) { return compose(top, bottom, left, right, zIndex)(props); });
Absolute.propTypes = __assign(__assign(__assign(__assign(__assign({}, styledSystemPropTypes.top), styledSystemPropTypes.right), styledSystemPropTypes.bottom), styledSystemPropTypes.left), styledSystemPropTypes.zIndex);
Absolute.displayName = 'Absolute';
export default Absolute;
var templateObject_1;
//# sourceMappingURL=Absolute.js.map